import { useState } from "react";
import {
	PaymentReceivedSearch,
	type PaymentReceivedSearchFilters,
	PaymentReceivedTable,
} from "./components";

function PaymentReceived({ relationId }: { relationId?: string }) {
	const [filters, setFilters] = useState<PaymentReceivedSearchFilters>({});

	return (
		<div className="flex flex-col gap-4">
			{!relationId && (
				<PaymentReceivedSearch filters={filters} onSearch={setFilters} />
			)}
			<PaymentReceivedTable filters={filters} relationId={relationId} />
		</div>
	);
}

export default PaymentReceived;
